module.exports = __webpack_public_path__ + "img/weed_pack.849aaa77.png";